import { z } from 'zod';
import { AuthorizedClient } from '~/app-modules/core/clients/authorized-client';
import { HttpConnection } from '~/app-modules/core/clients/http-connection';
import { AuthService } from '~/app-modules/auth/services/auth-service';
import {
  TUserAccessRightResponse,
  UserAccessRightResponse,
} from '~/app-modules/user-access-right/clients/dto/user-access-right-response';
import { PermissionType } from '~/app-modules/user-access-right/clients/enums/permission-type';
import { TCreateUserAccessRightRequest } from '~/app-modules/user-access-right/clients/dto/create-user-access-right-request';
import { UserStore } from '~/app-modules/user/stores/user.store';

@singleton()
export class UserAccessRightClient extends AuthorizedClient {
  constructor(http: HttpConnection, authService: AuthService, userStore: UserStore) {
    super(http, authService, userStore);
  }

  async getPermissionsByUserId(userId: string): Promise<TUserAccessRightResponse[]> {
    return await this.executeRequest(
      {
        method: 'get',
        url: `/ui/v1/user-access-right/by-user/${userId}`,
      },
      z.array(UserAccessRightResponse),
    );
  }

  async getPermissionsForCurrentUser(): Promise<PermissionType[]> {
    return await this.executeRequest(
      {
        method: 'get',
        url: '/ui/v1/user-access-right/current-user/business-area-permissions',
      },
      z.array(z.nativeEnum(PermissionType)),
    );
  }

  async hasGlobalEditUserRolesPermission(): Promise<boolean> {
    return await this.executeRequest(
      {
        method: 'get',
        url: '/ui/v1/user-access-right/current-user/has-global-edit-user-roles-permission',
      },
      z.boolean(),
    );
  }

  async grant(request: TCreateUserAccessRightRequest): Promise<void> {
    return await this.executeRequest({
      method: 'post',
      url: '/ui/v1/user-access-right',
      data: request,
    });
  }

  async revoke(userAccessRightId: string): Promise<void> {
    return await this.executeRequest({
      method: 'delete',
      url: `/ui/v1/user-access-right/${userAccessRightId}`,
    });
  }
}
